import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import EmailTemplate from './../models/EmailTemplate';


export function getEmailTemplates(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EMAIL_TEMPLATE_LIST,
        params: params,
        parser: emailTemplatesDataParser,
    }).get();
}

export function getEmailTemplateDetail(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EMAIL_TEMPLATE_DETAIL,
        endpointParams: { id },
        parser: (data) => new EmailTemplate(data.data),
    }).get();
}

export function createEmailTemplateDetail(emailTemplate) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EMAIL_TEMPLATE_ACTION,
        parser: (data) => new EmailTemplate(data.emailTemplate),
    }).post(emailTemplate.export());
}

export function updateEmailTemplateDetail(emailTemplate) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EMAIL_TEMPLATE_ACTION,
        // endpointParams: { id: emailTemplate.id },
        parser: (data) => new EmailTemplate(data.emailTemplate),
    }).put(emailTemplate.export());
}

export function deleteEmailTemplateDetail(emailTemplate) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EMAIL_TEMPLATE_ACTION,
        params: { id: emailTemplate.id },
        // parser: (data) => new EmailTemplate(data.emailTemplate),
    }).delete();
}

export function createEmailTemplateTranslate(emailTemplate) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EMAIL_TEMPLATE_TRANSLATE_CREATE,
    }).post(emailTemplate.export(true).translate());
}

export function updateEmailTemplateTranslate(emailTemplate) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EMAIL_TEMPLATE_TRANSLATE_UPDATE,
    }).put(emailTemplate.export(true).translate());
}

export function deleteEmailTemplateTranslate(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EMAIL_TEMPLATE_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

const emailTemplatesDataParser = (data) => ({
    emailTemplates: (data.data.result || []).map(item => new EmailTemplate(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
});


